import React from 'react'
import Text from '../components/Text.js'

import { breakpoints } from '../constants/theme'


export default props => (
  <Text
    tag='h4'
    {...props}
    bold
    size={0}
    height={0}
 />
)



// WEBPACK FOOTER //
// ../styleguide/Heading4.js